import { providerType } from './clients.js';
import { presetOf } from './presets.js';
import { t } from './i18n.js';

/* Los proveedores se agrupan por tipo en los selectores («Mostrar por proveedor»): primero lo propio (bibliotecas, archivos y
   nubes), luego la televisión por lista y los canales gratuitos. Las etiquetas son las de la pantalla de conectar. */

export const PROVIDER_GROUPS = ['library', 'files', 'iptv', 'free'];

/** Grupo de un proveedor guardado: library | files | iptv | free. */
export function providerGroup(profile) {
    if (!profile) return 'iptv';
    if (profile.type === 'archive' || presetOf(profile)) return 'free';
    const g = providerType(profile.type).group;
    if (g === 'library') return 'library';
    if (g === 'files' || g === 'storage') return 'files';
    return 'iptv';
}

/** Icono según el tipo (una lista pública, el suyo propio). */
export function providerIcon(profile) {
    const preset = presetOf(profile);
    return (preset && preset.icon) || providerType(profile && profile.type).icon || 'dns';
}

/**
 * Elementos de un selector: agrupados por tipo, con el nombre del grupo en cada elemento (el selector pone el título cuando
 * cambia). `choices` = catalog.providerChoices() (con group e icon); `idOf` da el id de cada elemento.
 */
export function providerPickerItems(choices, idOf = (p) => p.id) {
    const out = [];
    PROVIDER_GROUPS.forEach((g) => {
        choices.filter((p) => (p.group || 'iptv') === g).forEach((p) => out.push({ id: idOf(p), name: p.name, icon: p.icon || 'dns', group: t('login.group.' + g) }));
    });
    // Lo que no encaje en ningún grupo (no debería pasar) va al final, sin título.
    choices.filter((p) => PROVIDER_GROUPS.indexOf(p.group || 'iptv') === -1).forEach((p) => out.push({ id: idOf(p), name: p.name, icon: p.icon || 'dns' }));
    return out;
}
